<template>
  <div class="mb-10 flex size-full flex-col items-center md:max-w-7xl md:px-5 lg:px-10">
    <div class="mb-3 flex w-full items-center px-2 md:px-0">
      <p class="flex flex-col self-end text-xl text-gray-700 md:text-2xl lg:text-3xl">
        <span>Subsidios de despacho</span>
        <a
          :href="`/makers/${maker.slug}`"
          class="mt-1 text-sm font-light hover:underline md:text-base"
        >
          Revisar subsidios
        </a>
      </p>
    </div>
    <div class="flex size-full flex-col rounded-md bg-white px-2 py-3 text-gray-700 md:px-4 md:py-5 lg:px-10">
      <lokal-loading
        v-if="subsidizedShippingIsLoading"
        :loading="subsidizedShippingIsLoading"
      />
      <template v-else>
        <p
          v-if="orderedSubsidizedShippings && orderedSubsidizedShippings?.length === 0"
          class="text-sm md:text-base"
        >
          No hay subsidios de despacho activos.
        </p>
        <makers-subsidized-shipping-list-card
          v-for="subsidizedShipping in orderedSubsidizedShippings"
          :key="subsidizedShipping.id"
          :subsidized-shipping="subsidizedShipping"
        />
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { orderBy } from 'lodash';
import makersSubsidizedShippingListCard from './makers-subsidized-shipping-list-card.vue';
import useSubsidizedShippingsQuery from './queries/subsidized-shippings-query';

const props = defineProps<{
  maker: Maker;
}>();

const subsidizedShippingQueryParams = computed(() => 'q[active_eq]=true');
const { subsidizedShippingIsLoading, subsidizedShippings } = useSubsidizedShippingsQuery(
  computed(() => props.maker.id),
  subsidizedShippingQueryParams,
);
const orderedSubsidizedShippings = computed(() => {
  return orderBy(subsidizedShippings.value, ['minimumAmountCents'], ['asc']);
});
</script>
